export const INSIGHT_FEEDBACK_SENTIMENT = {
  HELPFUL: 'HELPFUL',
  NOT_HELPFUL: 'NOT_HELPFUL'
};
export const INSIGHT_FEEDBACK_CATEGORIES = {
  HELPFUL: ['ACCURACY', 'RELEVANCE', 'TIMELINESS', 'USABILITY', 'OTHER'],
  NOT_HELPFUL: ['INACCURACY', 'IRRELEVANCE', 'OUTDATED', 'COMPLEXITY', 'OTHER']
};